// extracted by mini-css-extract-plugin
export default {"switch":"ToogleSwitch_switch__dDSBN","slider":"ToogleSwitch_slider__8DnCu","round":"ToogleSwitch_round__jVZIA"};